import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-go-digital',
  templateUrl: './why-go-digital.component.html',
  styleUrls: ['./why-go-digital.component.sass']
})
export class WhyGoDigitalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
